export default {
	tenantId: "tahoe_uat",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "tahoe--uat"
	}
}
